/**
 * 生成の入口（FR-INIT-01〜06）。
 * 明示生成（create）と、所定クラスを持つ要素の宣言的初期化（parse）を提供する。
 */
import { cls } from '../brand';
import type { ViewerOptionsInput } from './options';
import { Viewer } from './viewer';

/** 宣言的初期化のマーカークラス。 */
const INIT_CLASS = cls('book');

/** 要素 1 つにつきビューワ 1 つ。二重生成を防ぐ。 */
const instances = new WeakMap<Element, Viewer>();

function live(el: Element): Viewer | undefined {
  const viewer = instances.get(el);
  return viewer && viewer.getState().status !== 'disposed' ? viewer : undefined;
}

/** 要素にビューワを生成する。同じ要素への再生成は既存インスタンスを返す。 */
export function create(el: Element, options: ViewerOptionsInput = {}): Viewer {
  const existing = live(el);
  if (existing) return existing;

  const viewer = new Viewer(el as HTMLElement, options);
  instances.set(el, viewer);
  void viewer.init();
  return viewer;
}

/**
 * DOM を走査し、未初期化のマーカー要素をビューワにする。
 * 後から挿入された DOM にも使える（FR-INIT-06）。
 */
export function parse(root: ParentNode = document): Viewer[] {
  return [...root.querySelectorAll(`.${INIT_CLASS}`)]
    .filter((el) => !live(el))
    .map((el) => create(el));
}

/** 読み込み完了時に一度だけ宣言的初期化を行う。 */
export function autoInit(): void {
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => parse(), { once: true });
  } else {
    parse();
  }
}
